/**
 * Zeilenkästen einer Textauswahl — NUR aus den Textebenen von PDF.js.
 *
 * `range.getClientRects()` taugt dafür nicht: überspannt die Auswahl
 * Elementgrenzen (z. B. von Seite 1 auf Seite 2), liefern Browser zusätzlich die
 * Kästen ganzer Elemente mit — Canvas-Ebene, Annotationsebene, die ganze Seite.
 * Als Markierung übernommen, würde das ganze Seiten löschen. Deshalb wird jeder
 * Textknoten innerhalb einer `.textLayer` einzeln vermessen, mit genau dem
 * ausgewählten Teil (Start-/End-Offset).
 */
export function textRechteckeDerAuswahl(range: Range): DOMRect[] {
    const kaesten: DOMRect[] = [];
    const nimm = (t: Text) => {
        if (!t.parentElement?.closest(".textLayer")) return;
        if (!range.intersectsNode(t)) return;
        const start = t === range.startContainer ? range.startOffset : 0;
        const ende = t === range.endContainer ? range.endOffset : t.length;
        if (ende <= start) return;
        const teil = t.ownerDocument.createRange();
        teil.setStart(t, start);
        teil.setEnd(t, ende);
        kaesten.push(...Array.from(teil.getClientRects()));
    };
    const wurzel = range.commonAncestorContainer;
    if (wurzel.nodeType === Node.TEXT_NODE) {
        nimm(wurzel as Text);
    } else {
        const lauf = (wurzel.ownerDocument ?? document).createTreeWalker(wurzel, NodeFilter.SHOW_TEXT);
        for (let n = lauf.nextNode(); n; n = lauf.nextNode()) nimm(n as Text);
    }
    return kaesten;
}

/** Alle Zeilenkästen einer Auswahl (über alle Ranges). */
export function textRechteckeDerSelection(sel: Selection): DOMRect[] {
    const kaesten: DOMRect[] = [];
    for (let i = 0; i < sel.rangeCount; i++) kaesten.push(...textRechteckeDerAuswahl(sel.getRangeAt(i)));
    return kaesten;
}
